import marketHeaderMixin from '@/mixins/marketHeader';

export default {
  mixins: [
    marketHeaderMixin,
  ],
  computed: {
    classModifier() {
      return {
        'market-header-title-large__header': true,
        'market-header-title-large__header--right-padding': this.watchIconVisible,
      };
    },
  },
  methods: {
    onClick() {

    },
  },
};



// WEBPACK FOOTER //
// ./src/components/market/market-header-title-large/market-header-title-large.js